<script setup lang="ts">
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";

interface Props {
  dtwin: Dtwin | null | undefined;
  deviceModelUiConfig: Record<string, DynamicUIDetail[]>;
}

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <block-container
    v-if="dtwin"
    :title="t('dtwins.form.description.connectivity.title')"
    with-top-separator
  >
    <template #left>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.left"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
    <template #right>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.right"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
  </block-container>
</template>
